import { RainbowContext, RainbowMiddleware } from '~/context/RainbowContext';

const isFromCrawler: RainbowMiddleware = (context: RainbowContext) => {
  context.store.commit('szukaj/isFromCrawler', context?.$ua.isFromCrawler());
};

export default isFromCrawler;
